import { FC } from 'react';
import { AdventCalendarBlockStoryblok } from 'storyblok-types';
import { getProductsByReferenceKeys } from 'commerce/scayle/product-management';
import {
  AdventCalendarBlockBody,
  AdventCalendarBlockBodyProps,
} from './AdventCalendarBlockBody';

export const AdventCalendarBlock: FC<{
  blok: AdventCalendarBlockStoryblok;
}> = async ({ blok }) => {
  if (!blok.product_key) {
    return null;
  }
  const { response, error } = await getProductsByReferenceKeys([
    blok.product_key,
  ]);
  return error ? null : (
    <AdventCalendarBlockBody
      blok={
        {
          ...blok,
          price: response?.[0]?.variants?.[0]?.price,
          isSoldOut: !response?.[0]?.variants?.[0]?.stock,
          href: response?.[0]?.href,
        } as AdventCalendarBlockBodyProps
      }
    />
  );
};
